import {useEffect, useState} from 'react';

// Module-scoped keyword store, so the search input in the table toolbar and the
// list hook that does the filtering are looking at the SAME keyword. A local
// useState in each would let the input read empty while the list stayed
// narrowed. Matches the store in the pipelines module (FNP-815).
let globalKeyword = '';
const searchListeners: Set<(keyword: string) => void> = new Set();

const notifySearchChange = (keyword: string) => {
    globalKeyword = keyword;
    searchListeners.forEach(listener => listener(keyword));
};

export const useExecutionsSearch = () => {
    const [keyword, setKeyword] = useState(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        searchListeners.add(listener);
        return () => {
            searchListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifySearchChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};

// Test-only reset. The store outlives a component unmount by design, which
// would otherwise leak one test's keyword into the next.
export const resetExecutionsSearch = () => {
    notifySearchChange('');
};
